import { IOneMessageJson } from "../../../../../../nodeserver/structs/database.js";
import JSX from "./../../../helpers/react.js";
import RefObject = JSX.RefObject;
import { canChangeOrSeeMessage } from "../../../messages/helpers.js";
import { ServerApi } from "../../../api.js";

export function RestoreActionElement(props: {
    msg: IOneMessageJson
}){
    const restoreMessageElement = props.msg.deleted && canChangeOrSeeMessage(props.msg.deleted_by_id) ?
        (<div className="restore-message message-action-padding action-element"
              onClick={() => messageRestoreClickEventHandler(props.msg.id)}
        >
            <img src="/img/restore.svg" className="action-element-img"/>
        </div>) : <></>;
    return restoreMessageElement;
}


async function messageRestoreClickEventHandler(messageId: number) {
    await ServerApi.messages.restoreMessage(messageId);
}
